import json from './sprite.js';

export default {
    handle: 'SP_SPS9-ArtSupplies',
    label: 'es_SPS9-ArtSupplies_234685997',
    json,
};
